<h2>{{'About' | translate}}</h2>

<h3 class="title">Hochschule Campus Wien</h3>
<p>
  Im interdisziplinären Forschungsteam der Hochschule arbeiten Expert*innen aus den Bereichen Digital Health and Care und Health Assisting Engineering, Psychologie, Ergotherapie, Angewandte Pflegewissenschaft, und Soziale Arbeit sowie Software Engineering und Digital Communications zusammen.
</p>

<h3 class="title">NOUS</h3>
<p>
  NOUS Wissensmanagement FlexCo entwickelt seit 2006 erfolgreich mobile Applikationen für Museen und andere Kunst- und Kulturinstitutionen sowie seit 2008 native Applikationen für iOS und seit 2009 für Android. Seit 2012 gehört darüber hinaus die Programmierung von Webapplikationen zu unserem Portfolio.

  Derzeit beschäftigt NOUS mehr als zwanzig Mitarbeiter darunter Softwarespezialist*innen und Kulturwissenschafter*innen - ein interdisziplinäres Team, das für state-of-the-art Entwicklung und ausdifferenzierten Research sowie hochqualitatives Projektmanagement stehen. Darüber hinaus verfügt NOUS über ein Netzwerk von Expert*innen in den Bereichen Usability, Content Scripting, Multimediaproduktion, Softwareentwicklung und Interfacedesign.
</p>


